module.exports = "/_next/static/images/teaser2-slice-1-a34775021a95def7e8b162a43652c57e.jpg";